import { del } from './requests'

export function destroyOrganization (reason) {
  return del('organization', { reason })
}
